/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Reset_LabelInputs */

const en_camera_reset_label = /** @type {(inputs: Camera_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset view`)
};

const fr_camera_reset_label = /** @type {(inputs: Camera_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser`)
};

const ms_sg2_camera_reset_label = /** @type {(inputs: Camera_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapkan semula`)
};

/**
* | output |
* | --- |
* | "Reset view" |
*
* @param {Camera_Reset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_reset_label = /** @type {((inputs?: Camera_Reset_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Reset_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_reset_label(inputs)
	if (locale === "fr") return fr_camera_reset_label(inputs)
	return ms_sg2_camera_reset_label(inputs)
});